import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { IgnoredFaultService } from "../../../../services/api/ignored-faults/ignored-faults.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MessageService } from "@openng/optimus-ui/api";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { IgnoredFaultCodePayload } from "../../../../models/api/fault/ignoredFaultCode";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { TextareaModule } from "@openng/optimus-ui/textarea";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { TrimInputDirective } from "../../../../shared/directives/trim-input/trim-input.directive";
@Component({
  selector: "app-fault-ignore-form",
  imports: [ReactiveFormsModule, TranslateModule, InputTextModule, TextareaModule, ButtonComponent, TrimInputDirective],
  templateUrl: "./fault-ignore-form.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./fault-ignore-form.scss",
})
export class FaultIgnoreForm {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);
  private ignoredFaultService = inject(IgnoredFaultService);
  private message = inject(MessageService);
  private translate = inject(TranslateService);

  public actionType: "add" | "edit" = this.config.data.actionType;

  private ignoredFaultId = this.config.data.fault?.id;
  private ignoredFaultCode = this.config.data.fault?.code;
  private ignoredFaultDescription = this.config.data.fault?.description;
  public form: FormGroup = new FormGroup({
    code: new FormControl(this.ignoredFaultCode, { validators: [Validators.required, Validators.maxLength(100)] }),
    description: new FormControl(this.ignoredFaultDescription, { validators: [Validators.maxLength(500)] }),
  });

  /**
   * Closes the dialog
   */
  public closeDialog(success = false) {
    this.ref.close(success);
  }

  /**
   * Gets all values from the form and updates/creates the fault ignore list.
   * If creating/updating was successful the dialog is closed.
   */
  public save() {
    if (this.form.valid) {
      const formValues = this.form.getRawValue();
      const payload: IgnoredFaultCodePayload = {
        code: formValues.code,
        description: formValues.description,
      };
      const observable =
        this.actionType === "add"
          ? this.ignoredFaultService.addIgnoredFault(payload)
          : this.ignoredFaultService.updateIgnoredFault(payload, this.ignoredFaultId);
      observable.subscribe({
        next: (response) => {
          if (response) {
            this.message.add({
              key: "global",
              severity: "success",
              summary: this.translate.instant("common.success"),
              detail: this.translate.instant(`ignored_fault_list.${this.actionType}_fault_success`),
            });
            this.closeDialog(true);
          }
        },
      });
    }
  }
}
